import { useTranslation } from "react-i18next";
import DangerPic from "../default_images/danger_deletion.svg";
import PropTypes from "prop-types";
import TeambookDialog from "./TeambookDialog";

const TeambookDialogDangerAction = ({
  open,
  setOpen,
  contentText,
  buttonText,
  actionRequest,
}) => {
  const { t } = useTranslation();

  return (
    <TeambookDialog
      onClose={() => setOpen(false)}
      open={open}
      title={" "}
      withCloseButton
      content={
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <img className="danger-pic" src={DangerPic} alt={"danger"}/>
          <p style={{marginBottom: "0px"}}>{contentText}</p>
        </div>
      }
      actionButtons={[
        {
          text: buttonText || t("delete"),
          onClick: () => {
            actionRequest();
            setOpen(false);
          },
          type: "blue",
        },
        {
          text: t("cancel"),
          onClick: () => setOpen(false),
          type: "outlined",
        },
      ]}
    />
  );
}

TeambookDialogDangerAction.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  contentText: PropTypes.string,
  buttonText: PropTypes.string,
  actionRequest: PropTypes.func,
}

export default TeambookDialogDangerAction;
